import { NumberFormatter } from '@internationalized/number';
import type { Locale } from '~/i18n/i18n-config';

export const CURRENCIES = ['GBP', 'AUD', 'CAD', 'CHF', 'DKK', 'EUR', 'NOK', 'NZD', 'SEK', 'USD'] as const;
export type CurrencyName = (typeof CURRENCIES)[number];
export type CurrencyCookie = CurrencyName | undefined;

export const isValidCurrency = (value: string): value is CurrencyName =>
  (CURRENCIES as readonly string[]).includes(value);

export const getCurrencySymbol = (currency: CurrencyName): string =>
  new Intl.NumberFormat('en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' })
    .formatToParts(0)
    .find((part) => part.type === 'currency')?.value ?? currency;

// showDecimals defaults true — preserves V1 formatGBP behaviour (called without this arg)
export const createCurrencyFormatter = (locale: Locale, currency: CurrencyName, showDecimals = true) =>
  new NumberFormatter(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
    useGrouping: true,
    currencyDisplay: 'symbol'
  });
